module.exports = __webpack_public_path__ + "img/sand-rock-medium-04.f27bc3d6.png";